import { c as _c } from "react/compiler-runtime";
import { Box, ButtonBase, Dialog, Typography } from '@mui/material';
import { useFiltersAnalytics } from '../store/hooks/useFiltersAnalytics';
import type { MobileFilterCloseReason } from '../types';
import { Container } from './components/Container';
import { useFiltersDialogContext } from './components/FiltersDialogContext';
import { DIALOG_TITLE_ID, TITLE } from './constants';
export function RoundupFiltersMobile() {
  const $ = _c(23);
  const {
    fireApplyFilterEvents
  } = useFiltersAnalytics();
  const {
    isMobileFiltersDialogOpen,
    handleMobileFiltersDialogChange
  } = useFiltersDialogContext();
  let t0;
  if ($[0] !== fireApplyFilterEvents || $[1] !== handleMobileFiltersDialogChange) {
    t0 = t1 => {
      const {
        reason
      } = t1;
      fireApplyFilterEvents({
        reason
      });
      handleMobileFiltersDialogChange(false);
    };
    $[0] = fireApplyFilterEvents;
    $[1] = handleMobileFiltersDialogChange;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const closeDialog = t0;
  let t1;
  if ($[3] !== handleMobileFiltersDialogChange) {
    t1 = () => {
      handleMobileFiltersDialogChange(true);
      const activeElement = document.activeElement as HTMLElement;
      if (activeElement) {
        activeElement.blur();
      }
    };
    $[3] = handleMobileFiltersDialogChange;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const open = t1;
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      display: {
        xs: "block",
        sm: "none"
      }
    };
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      position: "relative",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      paddingX: 3,
      width: "100%",
      backgroundColor: "white",
      height: "40px",
      borderRadius: "8px",
      "--filters-button-background-offset": "8px",
      marginY: "var(--filters-button-background-offset)",
      "&:before": {
        content: "\"\"",
        position: "absolute",
        top: "calc(var(--filters-button-background-offset) * -1)",
        left: "calc(var(--filters-button-background-offset) * -1)",
        width: "calc(100% + var(--filters-button-background-offset) * 2)",
        height: "calc(100% + var(--filters-button-background-offset) * 2)",
        backgroundColor: "neutral.lightest",
        borderRadius: "8px",
        zIndex: -1
      }
    };
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Typography variant="text" sx={{
      fontWeight: 500,
      color: "text.secondary"
    }}>{TITLE}</Typography>;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <span aria-hidden="true" className="mask-icon mask-icon-tune" style={{
      width: "20px",
      height: "20px",
      backgroundColor: "#64666A"
    }} />;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== open) {
    t6 = <ButtonBase disableRipple={true} onClick={open} aria-label={`Open ${TITLE} dialog`} sx={t3}>{t4}{t5}</ButtonBase>;
    $[9] = open;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== closeDialog) {
    t7 = () => closeDialog({
      reason: "esc_key"
    });
    $[11] = closeDialog;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      paper: {
        sx: {
          "--filters-dialog-padding": "1rem",
          padding: "var(--filters-dialog-padding)"
        }
      }
    };
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== closeDialog) {
    t9 = <Container closeDialog={closeDialog} />;
    $[14] = closeDialog;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== isMobileFiltersDialogOpen || $[17] !== t7 || $[18] !== t9) {
    t10 = <Dialog open={isMobileFiltersDialogOpen} onClose={t7} fullScreen={true} keepMounted={false} aria-labelledby={DIALOG_TITLE_ID} slotProps={t8}>{t9}</Dialog>;
    $[16] = isMobileFiltersDialogOpen;
    $[17] = t7;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t10 || $[21] !== t6) {
    t11 = <Box sx={t2}>{t6}{t10}</Box>;
    $[20] = t10;
    $[21] = t6;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  return t11;
}